import { useContext } from "react";

import { useTranslation } from "react-i18next";

import moment, { Moment } from "moment";
import {
    DateValidationError,
    PickerChangeHandlerContext
} from "@mui/x-date-pickers";

import DatePicker, { useDatePicker } from "components/DatePicker";
import TimeZoneContext from "context/timeZone/timeZoneContext";
import { YYYY_MM_DD_HH_mm_ss } from "shared";

import { ExpirationDateProps } from "./types";

const ExpirationDate = ({
    expirationDate,
    isActive,
    isLoading,
    onExpirationDateChange,
    onExpirationDateError,
    customStyle
}: ExpirationDateProps) => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const { t } = useTranslation();
    const { parseDatePickerValue, getLocalDate } = useDatePicker();

    const handleExpirationDateChange = (
        dateValue: Moment | null,
        context: PickerChangeHandlerContext<DateValidationError>
    ) => {
        const newExpDate = parseDatePickerValue(
            dateValue,
            context,
            expirationDate,
            true
        );

        const newExpPayload =
            dateValue === null || context.validationError
                ? null
                : getLocalDate(dateValue).utc().format(YYYY_MM_DD_HH_mm_ss);

        onExpirationDateChange(newExpDate, newExpPayload);
    };

    return (
        <DatePicker
            timezone={currentTimeZone}
            label={`${t("Table##expiration date")} (${t("Dialog##optional")})`}
            disablePast
            value={expirationDate ? moment.utc(expirationDate) : null}
            shouldDisableDate={date =>
                date.isSame(moment().tz(currentTimeZone), "day")
            }
            readOnly={isActive && isLoading}
            disabled={!isActive}
            onChange={handleExpirationDateChange}
            getError={onExpirationDateError}
            customStyle={customStyle}
        />
    );
};

export { ExpirationDate };
